import { EngineBaseline } from "./schema"
export interface EngineRange { minimum: number; fromPctOfMax?: (pct: number) => number }
/** Content selects supported scaling forms; tuning remains an engine contract. */
export const resolveEngineValues = <T>(data: unknown, baselines: Record<EngineBaseline, EngineRange>): T => {
    const visit = (value: any): any => {
        if (Array.isArray(value)) return value.map(visit)
        if (value && typeof value === "object") {
            if (value.baseline !== undefined) {
                const base = baselines[value.baseline]
                if (!base) throw new Error(`Unknown engine baseline ${value.baseline}`)
                const amount = value.pctOfMax === undefined ? base.minimum : base.fromPctOfMax?.(value.pctOfMax)
                if (amount === undefined) throw new Error(`Baseline ${value.baseline} does not support percentage scaling`)
                return amount * (value.multiplier ?? 1)
            }
            return Object.fromEntries(Object.entries(value).map(([key, v]) => [key, visit(v)]))
        }
        return value
    }
    return visit(data)
}
